exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scanner-container[data-v-0f16a28f]{position:fixed;-webkit-transition:top .5s ease;transition:top .5s ease;top:100vh;left:0;width:100vw;height:100vh;text-align:center;background:#fff;padding:90px 10px 10px}.scanner-container.show[data-v-0f16a28f]{top:0}.scanner-wrapper[data-v-0f16a28f]{width:400px;margin:0 auto;max-width:90%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f16a28f","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/fireExtinguishers/ScannerComponent.vue
// module id = BfQk
// module chunks = 0